import { IEnvironmentDetails } from "./../../interfaces/environment-details";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-networks-to-peer",
  templateUrl: "./networks-to-peer.component.html",
  styleUrls: ["./networks-to-peer.component.sass"],
})

export class NetworksToPeerComponent implements OnInit {

  @Input() selectedEnvironments: IEnvironmentDetails[];
  @Output() deleteEnv = new EventEmitter<IEnvironmentDetails>();

  constructor() {}

  ngOnInit(): void {
  }

  deleteEnvironment(environment: IEnvironmentDetails) {
    this.deleteEnv.emit(environment);
  }

}
